import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { KITS } from '../data/kits';
export function FinalCTA() {
  return <section className="py-24 bg-cream overflow-hidden relative" data-id="element-344">
      {/* Background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gold/5 blur-3xl rounded-full pointer-events-none" data-id="element-345" />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-346">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-347">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-ink mb-6 leading-tight" data-id="element-348">
            Ya decidiste mejorar tu alimentación.
            <br data-id="element-349" />
            <span className="text-gold" data-id="element-350">
              Ahora elegí el kit que puede cambiar tu rutina.
            </span>
          </h2>
          <div className="flex flex-col items-center gap-4 mb-12" data-id="element-351">
            <CountdownTimer variant="large" data-id="element-352" />
            <p className="text-sm font-medium text-ink-light" data-id="element-353">
              Precio promocional activo por tiempo limitado.
            </p>
          </div>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-354">
          {KITS.map((kit, index) => <motion.div key={kit.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-premium border border-ink/5 text-center flex flex-col" data-id="element-355">
              <div className={`text-xs font-bold tracking-wider mb-4 ${kit.textColor}`} data-id="element-356">
                {kit.badge}
              </div>
              <h3 className="font-serif font-bold text-xl text-ink mb-2" data-id="element-357">
                {kit.name}
              </h3>
              <div className="text-2xl font-bold text-ink mb-6" data-id="element-358">
                ${kit.price.toLocaleString('es-AR')}
              </div>
              <a href="#kits" className={`
                  mt-auto w-full py-3 rounded-full font-bold text-sm transition-all text-white
                  ${kit.color} hover:opacity-90 shadow-md hover:shadow-lg
                `} data-id="element-359">
                ELEGIR ESTE KIT
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}